import {urlValidation, getImageUrl, onError, message, errorHandler, logout, loader, removeProtocol, routeErrorHandler, beforeAvatarUpload} from '@/libs/helper'
import {isEmpty, filter, cloneDeep} from 'lodash'
import constants from '@/libs/constant/constants'
import {createScreenName, createOrganisation, updateOrganisation, uploadImage, getImageUploadURL, getScreenNameDetails, updateLocationDetail} from '@/libs/api/api';
import ManageAuthorImage from '@/components/pages/Card/Author/ManageAuthorImage/ManageAuthorImage.vue'
import 'quill-mention';
import mentionListMixin from '@/mixins/mentionListMixin'
import countrycode from '@/libs/constant/countrycode'
import pageRoute from '@/libs/constant/pageRoutes'
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'
import locationFormMixin from '@/mixins/locationFormMixin';

export default {
  name: "OrganisationForm",
  components: { ManageAuthorImage },
  mixins: [
    mentionListMixin,
    OrganisationRolesErrorHandlerMixin,
    locationFormMixin,
  ],
  props: {
    displayLocation: {
      type: Boolean,
      default: true,
    },
    isAdd: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => {},
    },
    updateFormDataValues: {
      type: Function,
      default: () => {}
    },
    isRename: {
        type: Boolean,
        default: false
    },
    closeRenamePopup: {
      type: Function,
      default: () => {}
    },
    hasPermission: {
      type: Boolean,
      default: true
    }
  },
    data() {
        return {
            onError,
            getImageUrl,
            // countrydata,
            file: {},
            uploadImageData:{},
            imagePreview: this.formData && this.formData.imagePreview || null,
            imageName: this.formData && this.formData.imageName || '',
            imageAvatar: this.formData.avatar_image || null,
            imageBlobData: this.formData && this.formData.imageBlobData || null,
            beforeAvatarUpload,
            publisher: {
                name: this.formData.name || '',
                screen_name: this.formData.screen_name || '',
                website: removeProtocol(this.formData.url || this.formData.website || ''),
                registration_number: this.formData.registration_number || '',
                biography: this.formData.biography || '',
                short_description: this.formData.short_description || '',
                biography_html: this.formData.biography_html || '',
                short_description_html: this.formData.short_description_html || '',
                email: this.formData.email || '',
                billing_email: this.formData.billing_email || ''
            },
            organisation: {
                name: this.formData.name || '',
                screen_name: this.formData.screen_name || '',
            },
            address: {
                line1: (this.formData && this.formData.line1) || (this.formData && this.formData.address && this.formData.address.line1) || '',
                line2: (this.formData && this.formData.line2) || (this.formData && this.formData.address && this.formData.address.line2) || '',
                postal_code: (this.formData && this.formData.postal_code) || (this.formData && this.formData.address && this.formData.address.postal_code) || '',
                city: (this.formData && this.formData.city) || (this.formData && this.formData.address && this.formData.address.city) || '',
                country_code: (this.formData && this.formData.country_code) || (this.formData && this.formData.address && this.formData.address.country_code) || 'NL',
                country_name: (this.formData && this.formData.country_name) || (this.formData && this.formData.address && this.formData.address.country_name) || '',
                state: (this.formData && this.formData.state) || (this.formData && this.formData.address && this.formData.address.state)|| '',
                _id: (this.formData && this.formData._id) || (this.formData && this.formData.address && this.formData.address._id) || ''
            },
            contact_detail: {
                phone: (this.formData && this.formData.phone) || (this.formData && this.formData.contact_detail && this.formData.contact_detail.phone) || '',
                fax: (this.formData && this.formData.fax) || (this.formData && this.formData.contact_detail && this.formData.contact_detail.fax) || '',
                email: (this.formData && this.formData.email) || (this.formData && this.formData.contact_detail && this.formData.contact_detail.email) || ''
            },
            nameLimitValidation: function (rule, value, callback) {
                if(rule.field === 'middle_name' && value.split('').length === 0 ){
                    callback();
                } else if(value.split('').length < 2){
                    callback(new Error(window.i18next.t('Minimum 2 character required')));
                } else{
                    callback();
                }
            },
            validateSlug: function (rule, value, callback) {
                // eslint-disable-next-line
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                let checkSpaces = /\s/g
                if (isEmpty(value) || (value && value.length > 20)) callback(new Error(window.i18next.t('Invalid screen name')))
                if (regex.test(value)) callback(new Error(window.i18next.t('Invalid screen name')))
                if (checkSpaces.test(value)) callback(new Error(window.i18next.t('Spaces are not allowed')))
                else callback()
            },
            webSiteValidation: function (rule, value, callback) {
                if (isEmpty(value)) callback(new Error(window.i18next.t('Field should not be empty'))) 
                if (value && value !== '' && (value.includes('http://') || value.includes('https://'))) callback(new Error(window.i18next.t('Try adding url without web protocols(http or https)')))
                if (!urlValidation('https://' + value)) callback(new Error(window.i18next.t('Incorrect url'))) 
                else callback()
            },
            validateBillingEmail: function(rule, value, callback) {
                const re = /\S+@\S+\.\S+/;
                if(rule.field === 'email' && value.split('').length === 0 ){
                    callback(new Error(window.i18next.t('Please enter a valid email')));
                }
                else if (isEmpty(value) || ( value && !re.test(value))) {
                    callback(new Error(window.i18next.t('Invalid email'))) 
                }
                else callback() 
            },
            validateEmail: function (rule, value, callback) {
                const re = /\S+@\S+\.\S+/;
                if (isEmpty(value)) {
                  callback();
                } else if (value && !re.test(value)) {
                  callback(new Error(window.i18next.t("Invalid email")));
                }
            },
    }
  },
  async mounted () {
    if (!isEmpty(this.formData)) this.setRegisterCardDetails()
    await this.findState()
  },
  watch: {
    formData (newValue) {
        this.publisher = {
            name: (newValue && newValue.name) || '',
            screen_name: (newValue && newValue.screen_name) || '',
            website: removeProtocol((newValue && newValue.url) || (newValue && newValue.website) || ''),
            registration_number: (newValue && newValue.registration_number) || '',
            biography_html: (newValue && newValue.biography_html) || '',
            biography: (newValue && newValue.biography) || '',
            short_description: (newValue && newValue.short_description) || '',
            short_description_html: (newValue && newValue.short_description_html) || '',
            email: (newValue && newValue.email) || '',
            billing_email: (newValue && newValue.billing_email) || ''
        }
        this.organisation = {
            name: (newValue && newValue.name) || '',
            screen_name: (newValue && newValue.screen_name) || '',
        }
        this.address = {
            line1: (newValue && newValue.line1) || (newValue && newValue.address && newValue.address.line1) || '',
            line2: (newValue && newValue.line2) || (newValue && newValue.address && newValue.address.line2) || '',
            postal_code: (newValue && newValue.postal_code) || (newValue && newValue.address && newValue.address.postal_code) || '',
            city: (newValue && newValue.city) || (newValue && newValue.address && newValue.address.city) || '',
            country_code: (newValue && newValue.country_code) || (newValue && newValue.address && newValue.address.country_code) || 'NL',
            country_name: (newValue && newValue.country_name) || (newValue && newValue.address && newValue.address.country_name) ||'',
            state: (newValue && newValue.state) || (newValue && newValue.address && newValue.address.state) ||'',
            _id: (newValue && newValue.address && newValue.address._id) ||''
        }
        this.contact_detail = {
            phone: (newValue && newValue.phone) || (newValue && newValue.contact_detail && newValue.contact_detail.phone) || '',
            fax: (newValue && newValue.fax) || (newValue && newValue.contact_detail && newValue.contact_detail.fax) || '',
            email: (newValue && newValue.email) || (newValue && newValue.contact_detail && newValue.contact_detail.email) || ''
        }
        this.imagePreview = (newValue && newValue.imagePreview) || null
        this.imageName = (newValue && newValue.imageName) || ''
        this.imageAvatar = (newValue && newValue.avatar_image) || null
        this.imageBlobData = (newValue && newValue.imageBlobData) || null
        this.setRegisterCardDetails()
        // if(!this.isEdit){
        this.intialiseCountry()
        // this.findState()
        // }
        
    },
    '$route' (to, from) {
        if (to.params.id !== from.params.id) {
            this.getMentionList()
            // if(!isEdit){
            this.intialiseCountry()
            // }
        }
    }
  },
  async beforeMount() {
    // if(!this.isEdit){
    await this.intialiseCountry()
    // }
  },
    methods: {
        // to validate the postal code
        validatePostalCodeFunction(rule, value, callback) {
            if (this.address.country_name && this.address.country_name !== "") {
            let rex = countrycode.filter(
                (item) => item.name === this.address.country_name
            );
            if (rex[0].postal.test(value)) {
              callback();
            } else if (
                rex[0].postal !== "" &&
                value &&
                value !== "" &&
                !rex[0].postal.test(value)
            ) {
                callback(new Error(window.i18next.t("Invalid postal code")));
            }
            }
        },
        validateCountryName: function (rule, value, callback) {
            let rex = countrycode.filter(
              (item) => item.abbrev === this.address.country_code
            );
            if (rex.length == 0 || !value) {
              callback(
                new Error(window.i18next.t("Please enter valid country name"))
              );
            } else {
              callback();
            }
        },
        handleInputConfirm (item) {
            this.address.country_code = item.country_code || ''
            this.address.country_name = item.country_name || ''
            this.address._id = item._id || ''
            this.states = [];
            this.searchState = ''
            this.selectedState = {}
            this.fetchStateList(item)
        },
        querySearch: async function (search, cb) {
            if (search === '' && search === null && search.length < 1) return 
            let results = []
            if (!isEmpty(this.countries)) {
                 results = await filter(this.countries, (c) => {
                   return c.country_name.toLowerCase().includes(search.toLowerCase())
                })
            }
            cb(results)
        },
        /**
         * intialise country name
         */
          intialiseCountry () {
            // set address and by defult it is netherlands
            if ((this.formData && this.formData.country_code) || (this.formData && this.formData.address && this.formData.address.country_code)) {
                this.address.country_name = this.getCountryName()
            } else {
                this.address.country_name = (this.formData && this.formData.country_name) || (this.formData && this.formData.address && this.formData.address.country_name) || 'Netherlands'
            }
          //  await this.findState()
        },

    /**
     * route to organisations
     */
    routeToOrganisations() {
      this.$router.push({ name: pageRoute.organisationCard });
    },
    /**
     * save form organisation
     */
    saveOrganisationForm() {
      try {
        let forms = [
          "organisationImage",
          "organisationProfile",
          "organisationLocation",
        ];
        let description = document.getElementById(
          "quill-editor-description"
        ).innerText;
        let bio = document.getElementById("quill-editor-biography").innerText;
        this.publisher.biography = !isEmpty(bio) ? bio : "";
        this.publisher.short_description = !isEmpty(description)
          ? description
          : "";
        let isValid = true;
        if (!this.address.country_name) {
          isValid = false;
          return;
        }
        if (this.publisher.short_description === "") isValid = false;
        forms.map((form) => {
          if (this.$refs && this.$refs[form]) {
            this.$refs[form].validate((valid) => {
              if (!valid) {
                isValid = false;
                return;
              }
            });
          }
        });
        if (isValid) {
          this.uploadImage(this.file);
        }
      } catch (error) {
        console.error("error", error);
      }
    },
    /**
     * to get the country name
     */
     getCountryName() {
      let result = "";
      if (
        (this.formData && this.formData.country_code) ||
        (this.formData.address && this.formData.address.country_code)
      ) {
        filter(this.countries, (country) => {
          if (
            country.country_code ===
            (this.formData.country_code || this.formData.address.country_code)
          ) {
            result = country.country_name;
            // fetch state list initially
             this.fetchStateList(country);
          }
        });
      }
      return result;
    },
    /**
     * create screen name
     */
    createSlug() {
      if (this.publisher && isEmpty(this.publisher.name)) {
        return;
      }
      // body for api
      let body = {
        entity_type: "ORGANISATION",
        name: this.publisher.name,
      };
      createScreenName(body)
        .then((response) => {
          this.$set(this.publisher, "screen_name", response.response);
        })
        .catch(() => {});
    },
    /**
     * upload file
     * @param {*} file
     */
    uploadFile: async function (file) {
      this.imageName = file.file.name;
      this.file = file;
      this.imageBlobData = await this.createBlobObject({}, file.file);
      this.imagePreview = window.URL.createObjectURL(file.file);
    },
    /*
     * createBlobObject() creates and returns the binary image format to upload
     * */
    createBlobObject(uploadUrl, file) {
      return new Promise((resolve) => {
        let reader = new FileReader(file);
        reader.addEventListener("loadend", function (data) {
          return resolve({ imageData: data.target.result, uploadUrl });
        });
        reader.readAsArrayBuffer(file);
      });
    },
    /*
     * uploadImage() uploads the image to the s3 server
     * */
    async uploadImage(file) {
      try {
        let body = { ...this.publisher };
        body.url = `https://${this.publisher.website}`;
        delete body.website;
        if (!this.isEdit) {
          body.address = this.address;
          body.contact_detail = this.contact_detail;
          if (
            this.isShowStateField &&
            this.selectedState &&
            !isEmpty(this.selectedState)
          ) {
            body.address.state = this.selectedState._id;
          }
        }
        let description = await this.fetchScreenNamesDetails();
        let biography = await this.fetchScreenNamesDetails(true);
        if (description !== "") body.short_description_html = description;
        if (biography !== "") body.biography_html = biography;
        if (isEmpty(file)) {
          if (this.isEdit) this.updateOrganisationForm(body, true);
          else this.createOrganisationForm(body);
        } else {
          loader(this, true);
          getImageUploadURL({ imageName: this.imageName })
            .then((uploadUrls) => {
              this.uploadImageData = uploadUrls;
              return this.createBlobObject(uploadUrls, file.file);
            })
            .then((image) => {
              return uploadImage(image);
            })
            .then(() => {
              body.avatar_image = this.uploadImageData.fileKey;
              if (this.isEdit) this.updateOrganisationForm(body, true);
              else this.createOrganisationForm(body);
            });
        }
      } catch (error) {
        console.error(error);
        loader(this, false);
        message(
          this,
          constants.messageType.ERROR,
          errorHandler(
            error,
            logout.bind(this, this),
            routeErrorHandler.bind(
              this,
              this.$store.getters.getUserInformation.id
                ? {
                    name: pageRoute.usersOverview,
                    params: { id: this.$store.getters.getUserInformation.id },
                  }
                : {}
            )
          )
        );
        // error handler for permissions
        this.rolesErrorHandler(error);
      }
    },
    /**
     * debounce search
     */
    debounceSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        if (this.publisher.name) this.createSlug();
      }, 600);
    },
    /**
     * create form save
     */
    createOrganisationForm(body) {
      loader(this, true);
      let payload = {
        ...body.address
      };
      delete payload._id;
      payload = {
        ...body,
        address: payload,
      }
      createOrganisation(payload)
        .then(() => {
          loader(this, false);
          this.routeToOrganisations();
          let formData = {
            ...this.formData,
            ...this.publisher,
            avatar_image: this.imageAvatar,
            ...body,
          };
          // to update store
          this.updateStoreOrganisations(formData, true);
          // update account info
          this.$store.dispatch("setRefreshOrganisationList", true);
        })
        .catch((error) => {
          message(
            this,
            constants.messageType.ERROR,
            errorHandler(error, logout.bind(this, this))
          );
          loader(this, false);
        });
    },
    /**
     * update org form save
     */
    async updateOrganisationForm(body , isEditOrg=false ) {
      try {
        loader(this, true);
        const bodyToUpdate = { ...this.address, ...this.contact_detail };
        delete bodyToUpdate._id
        if (
          this.isShowStateField &&
          this.selectedState &&
          !isEmpty(this.selectedState)
        ) {
          bodyToUpdate.state = this.selectedState._id;
        }
        await updateLocationDetail(this.formData.address._id, bodyToUpdate);
        //conditionally modifying the body for update-organisation-api
          let body_updated;
          if(!isEditOrg)
            body_updated={...body }
          else{
                body_updated={ ...body }
                const body_temp = Object.fromEntries(
                Object.entries(body_updated)
                .filter(([key]) => !['address'].includes(key))
                );
                body_updated={...body_temp}
              }

        await updateOrganisation(body_updated, this.formData._id);

        let formData = {
          ...this.formData,
          ...this.publisher,
          avatar_image: this.imageAvatar,
          ...body,
          address: {...this.address , state: this.selectedState._id},
          contact_detail: this.contact_detail,
        };
        // to update the store values
        await this.updateStoreOrganisations(formData, true);
        // set the registered details
        await this.updateFormDataValues(formData);
        // close rename popup
        this.closeRenamePopup();
        // update account info
        this.$store.dispatch("setRefreshOrganisationList", true);
      } catch (error) {
        console.error("console.error(error)", error);
        message(
          this,
          constants.messageType.ERROR,
          errorHandler(
            error,
            logout.bind(this, this),
            routeErrorHandler.bind(
              this,
              this.$store.getters.getUserInformation.id
                ? {
                    name: pageRoute.usersOverview,
                    params: { id: this.$store.getters.getUserInformation.id },
                  }
                : {}
            )
          )
        );
        // error handler for permissions
        this.rolesErrorHandler(error);
      } finally {
        loader(this, false);
      }
    },
    /**
     * to select the screen name(manual) on the basis of regex
     */
    getScreenNames(html) {
      let result = [];
      // html is not null
      if (html !== null && html !== undefined) {
        let regex = /@[a-zA-Z0-9]{2}[a-zA-Z0-9-]*/g;
        // return screen names matches the regex
        result = html.match(regex);
      }
      return result;
    },
    /**
     * to fetch the screenNames from the
     * backend if any (@screen-name) is present
     * and validate it if it is a valid screen
     * name so create mention tag manually
     */
    async fetchScreenNamesDetails(isBiography) {
      try {
        // get html
        let html = isBiography
          ? document.getElementById("quill-editor-biography").innerHTML
          : document.getElementById("quill-editor-description").innerHTML;
        // to get the screen names which are not selected
        let screenNames = await this.getScreenNames(html);
        let result = ``;
        // if screen names are present
        if (!isEmpty(screenNames)) {
          // to create the body
          let screen_names = screenNames.map((item) =>
            item.replace("@", " ").trim()
          );
          // api call
          let response = await getScreenNameDetails({ screen_names });
          // if screen names exists, add tehm as tag
          response.map((mention) => {
            html = html.replace(
              new RegExp(`@${mention.screen_name}`, "g"),
              this.createMentionHTML(mention)
            );
          });
          // save it to share
          result = html;
        }
        return result;
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * to get the html for manually
     * created mention tags
     * @param {*} mention object
     */
    createMentionHTML(mention) {
      return `<span class="mention" data-denotation-char="@" data-id="${mention.id}" data-value="<a href=&quot;${mention.link}&quot; target=_blank>${mention.screen_name}" data-toggle="popover" data-link="${mention.link}" data-original-title="" title="">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">@</span><a href="${mention.link}" target="_blank">${mention.screen_name}</a></span></span>`;
    },
    /**
     * get the registerids and fetch the hovercard details
     */
    setRegisterCardDetails() {
      this.$nextTick(async () => {
        this.registerHoveCard();
        let ids = await this.getMentionIds();
        if (!isEmpty(ids)) {
          let list = await this.getMentionCardDetailList(ids);
          this.cardDetailList = list;
        }
      });
    },
    /**
     * to update the store value
     */
    updateStoreOrganisations(organisation, isNew) {
      let organisations = cloneDeep(this.$store.getters.getOrganisations);
      // if new push org
      if (isNew) organisations.push(organisation);
      // else update org
      else {
        organisations = organisations.map((org) => {
          if (org._id === organisation._id) org = organisation;
          return org;
        });
      }
      // update store
      this.$store.dispatch("setOrganisations", organisations);
    },

    /**
     * rename org
     */
    renameOrganisation() {
      this.$refs["organisationRenameForm"].validate((valid) => {
        if (!valid) return;
        let body = { ...this.publisher, ...this.organisation };
        body.url = `https://${this.publisher.website}`;
        delete body.website;
        body.address = this.address;
        this.updateOrganisationForm(body , true);
      });
    },

    /**
     * find state
     */
    async findState() {
      if (
        (this.formData && this.formData.country_code) ||
        (this.formData.address && this.formData.address.country_code)
      ) {
        // const findCountry = find(this.countries, {
        //   country_code:
        //     this.formData.country_code || this.formData.address.country_code,
        // });
        // another-approach
        let cc=this.formData.country_code || this.formData.address.country_code
        let findCountry=this.countries.find((c)=>c.country_code===cc)
        // ...
        if (findCountry) {
          await this.fetchStateList(findCountry);
          if (this.formData.address && this.formData.address.state) {
            // const findState = find(this.states, {
            //   _id: this.formData.address.state,
            // })
            let statetobeFind= this.formData.address.state
            let findState=this.states.find((state)=>state._id===statetobeFind)
            if (findState) {
              this.selectedState = findState;
              this.searchState = findState.state_code;
            }
          }
        }
      }
    },
  },
};
